import _APIInstance from "@/config/configApi";
import { API } from "@constants/common";
import { countryParams } from "@/models/Params";
import _APIInstanceServer from "@/config/configApiServer";

export class countryService {
  static async getAllCountries(params: countryParams) {
    try {
      const response = await _APIInstance.get(`${API.COUNTRY.GET_ALL}`, {
        params: params,
      });
      return response?.data;
    } catch (response: any) {
      return response.response.data;
    }
  }

  static async getAllCountriesServer(params: countryParams) {
    try {
      const response = await _APIInstanceServer.get(`${API.COUNTRY.GET_ALL}`, {
        params: params,
      });
      return response?.data?.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  }
}

export default countryService;
